import clsx from "clsx";
import React from "react";

type DividerProps = {
  direction?: "horizontal" | "vertical";
  color?: string;
  thickness?: string;
  length?: string;
};

const Divider: React.FC<DividerProps> = ({
  direction = "horizontal",
  color = "bg-panel-background",
  thickness,
  length,
}) => {
  const isVertical = direction === "vertical";
  const thicknessClass = thickness ?? (isVertical ? "w-px" : "h-px");
  const lengthClass = length ?? (isVertical ? "h-full" : "w-full");

  return <div className={clsx(color, thicknessClass, lengthClass, "block")} />;
};

export default Divider;
